import { BackwardsCompatibleKeyMap } from '@noriginmedia/norigin-spatial-navigation';
import { NavigationKeyMappings } from './buttons';

enum ControllerButtons {
  /**  Down */
  DOWN = 40,
  /**  Enter */
  ENTER = 13,
  /**  Esc */
  ESC = 27,
  /**  f */
  F = 70,
  /**  F1 */
  F1 = 112,
  /**  F10 */
  F10 = 121,
  /**  F2 */
  F2 = 113,
  /**  F3 */
  F3 = 114,
  /**  F5 */
  F5 = 116,
  /**  F6 */
  F6 = 117,
  /**  F7 */
  F7 = 118,
  /**  F8 */
  F8 = 119,
  /**  F9 */
  F9 = 120,
  /**  Left */
  LEFT = 37,
  /**  p */
  P = 80,
  /**  r */
  R = 82,
  /**  Right */
  RIGHT = 39,
  /**  space bar */
  SPACE = 32,
  /**  Up */
  UP = 38,
}

const NavigationButtons = {
  back: [ControllerButtons.ESC],
  down: [ControllerButtons.DOWN],
  enter: [ControllerButtons.ENTER],
  left: [ControllerButtons.LEFT],
  right: [ControllerButtons.RIGHT],
  up: [ControllerButtons.UP],
};

const MediaButtons = {
  fastForward: [ControllerButtons.F9],
  pause: [ControllerButtons.F10],
  play: [ControllerButtons.F5],
  playPause: [ControllerButtons.F8],
  rewind: [ControllerButtons.F7],
};

const CustomButtons = {
  exit: [ControllerButtons.F6],
  focusNavBar: [ControllerButtons.F1],
  toggleVideoContentVisibility: [
    ControllerButtons.ENTER,
    ControllerButtons.DOWN,
    ControllerButtons.F,
    ControllerButtons.F1,
    ControllerButtons.F2,
    ControllerButtons.F3,
    ControllerButtons.F5,
    ControllerButtons.F6,
    ControllerButtons.F9,
    ControllerButtons.F10,
    ControllerButtons.LEFT,
    ControllerButtons.P,
    ControllerButtons.R,
    ControllerButtons.RIGHT,
    ControllerButtons.SPACE,
    ControllerButtons.UP,
  ],
};

export const NAVIGATION_KEY_MAP: NavigationKeyMappings = {
  ...NavigationButtons,
  ...MediaButtons,
  ...CustomButtons,
} satisfies BackwardsCompatibleKeyMap;
